import { UncontrolledAlert } from 'reactstrap';
import { useEffect, useRef } from 'react';

interface AlertNotificationProps {
  type: keyof AlertPropsType;
  message?: string;
  heading: string;
  closeAction: () => void;
}
type AlertTypeProps = {
  color: string;
  icon: string;
};

type AlertPropsType = {
  success: AlertTypeProps;
  error: AlertTypeProps;
};

const AlertNotification = ({
  type,
  message = '',
  heading,
  closeAction,
}: AlertNotificationProps) => {
  const alertRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (heading && alertRef.current) {
      alertRef.current.focus();
    }
  }, [heading]);

  const alertProps: AlertPropsType = {
    success: {
      color: 'success',
      icon: 'ri-check-line',
    },
    error: {
      color: 'warning',
      icon: 'ri-alert-line',
    },
  };

  if (!heading) return null;

  return (
    <UncontrolledAlert
      data-testid="warn-alert-test"
      color={alertProps[type]?.color}
      className="alert-additional material-shadow mb-0"
      // toggle={() => {
      //   closeAction();
      // }}
      toggle={closeAction}
      innerRef={alertRef}
      tabIndex={-1}
    >
      <div className="alert-body">
        <div className="d-flex">
          <div className="flex-shrink-0 me-3">
            <i className={`${alertProps[type]?.icon} fs-16 align-middle`}></i>
          </div>
          <div className="flex-grow-1">
            <h5 className="alert-heading">{heading}</h5>
            {message && <p className="mb-0">{message}</p>}
          </div>
        </div>
      </div>
    </UncontrolledAlert>
  );
};

export default AlertNotification;
